module.exports = __webpack_public_path__ + "img/mywell_2.6fa236c4.webp";